import type { AppCopy } from '../catalogs';

export const csAppCopy = {
  welcomeHeading: 'Jak vám dnes mohu pomoci?',
  thinking: 'myšlení',
  scrollToBottom: 'Přejděte dolů',
  reasoning: 'Zdůvodnění',
  reasoningInProgress: 'probíhá',
  citationPages: 'Strany {first}–{last}',
  citationTitle: 'Úryvek ze zdroje',
  citationLoading: 'Načítání zdroje…',
  citationUnavailable: 'Citovaný text není dostupný nebo k němu již nemáte přístup.',
  citationOpen: 'Otevřít zdroj',
  citationCopied: 'Citace zkopírována',
  copy: 'Kopírovat',
  more: 'více',
  tryAgain: 'Zkuste to znovu',
  answerTruncated: 'Odpověď dosáhla limitu délky a byla oříznuta.',
  continueAnswer: 'Pokračovat v odpovědi',
  exportMarkdown: 'Exportovat jako Markdown',
  edit: 'Upravit',
  cancel: 'Zrušit',
  update: 'Aktualizovat',
  previous: 'Předchozí',
  next: 'Další',
  messagePlaceholder: 'Odeslat zprávu…',
  projectHomePlaceholder: 'Nový chat: {project}',
  sharedChatEveryone: 'Všichni ve společnosti {company} mohou číst tento chat',
  sharedChatOnePerson: 'Tento chat může číst 1 osoba',
  sharedChatPeople: 'Počet lidí, kteří mohou číst tento chat: {count}',
  forkedChatPlaceholder: 'Pokračujte se svými vlastními připojeními…',
  newAnswer: 'Nová odpověď',
  messageInput: 'Zadávání zpráv',
  sendMessage: 'Odeslat zprávu',
  stopGenerating: 'Přestaňte generovat',
  addAttachment: 'Přidat přílohu',
  removeFile: 'Odebrat soubor',
  attachmentPreview: 'Náhled přílohy',
  imageAttachmentPreview: 'Náhled obrázkové přílohy',
  image: 'Obrázek',
  openLink: 'otevřít odkaz',
  document: 'Dokument',
  file: 'Soubor',
  attachment: 'příloha',
  uploadFailed: 'nahrávání se nezdařilo',
  uploading: 'nahrávání',
  toolIncomplete: 'Nedokončeno',
  toolActivity: 'Aktivita',
  activityThinking: 'Přemýšlení…',
  activityWriting: 'Psaní…',
  activityWaiting: 'Čeká se na vaše schválení',
  activityStopped: 'Zastaveno',
  activityCouldNotFinish: 'Nepodařilo se dokončit',
  activitySources: 'zdrojů',
  activityShowThinking: 'Zobrazit přemýšlení',
  activityOpen: 'Otevřít aktivitu',
  activitySteps: 'Kroky',
  activitySourcesTab: 'Zdroje',
  activityUnavailable: 'Tato aktivita není dostupná.',
  activityInput: 'Vstup',
  activityOutput: 'Výstup',
  activityNoSources: 'Tato odpověď necituje žádné zdroje.',
  activityApprovedByReply: 'Schváleno vaší odpovědí',

  toolRunning: 'Probíhá',
  toolComplete: 'Dokončeno',
  toolNeedsApproval: 'Vyžaduje schválení',
  toolInput: 'Vstup',
  toolCall: 'volání nástroje',
  toolCalls: 'volání nástroje',
  openMenu: 'Otevřít nabídku',
  closeMenu: 'Zavřít nabídku',
  close: 'Zavřít',
  showInTextField: 'Zobrazit v textovém poli',
  settings: 'Nastavení',
  appearance: 'Vzhled',
  themeLight: 'Světlý',
  themeDark: 'Tmavý',
  themeSystem: 'Systémový',
  themeChoiceHelp:
    'Platí na všech vašich zařízeních. Volba „Systémový“ se řídí světlým nebo tmavým režimem každého zařízení.',
  themeSaveFailed: 'Vzhled se nepodařilo uložit, takže zůstal beze změny. Zkuste to znovu.',
  toolUsed: 'Použitý nástroj',
  toolCancelled: 'Zrušený nástroj',
  toolResult: 'výsledek:',
  toolError: 'Chyba:',
  toolCancelledReason: 'Důvod zrušení:',
  approvalAllow: 'Povolit',
  approvalAlwaysAllow: 'Vždy povolte',
  approvalDeny: 'Odmítnout',
  approvalAlwaysDeny: 'Vždy odmítnout',
  approvalConfirm: 'Potvrďte',
  approvalBack: 'Zpět',
  approvalApprovedResult: 'Schváleno uživatelem',
  approvalDeniedResult: 'Uživatel odepřel spuštění nástroje',
  logout: 'Odhlaste se',
  loginOrCreateAccount: 'Přihlásit se / Vytvořit účet',
  newChat: 'Nový chat',
  untitledChat: 'Chat bez názvu',
  previousChats: 'Předchozí chaty',
  openChat: 'Otevřete chat {title}',
  moreActionsForChat: 'Další akce pro {title}',
  chatActions: 'Chatové akce',
  closeChatActions: 'Zavřete akce chatu',
  deleteChatQuestion: 'Smazat chat?',
  deleteChatDescription: 'Chat „{title}“ bude trvale smazán.',
  deleteChat: 'Smazat chat',
  keepChat: 'Ponechat chat',
  delete: 'Smazat',
  deleting: 'Mazání…',
  chatDeleteFailed: 'Chat se nepodařilo smazat. Zkuste to znovu.',
  settingsDescription: 'Přizpůsobte si, jak vám asistent pracuje.',
  settingsDesktopDescription: 'Přizpůsobte si, jak na vás asistent reaguje.',
  personalization: 'Personalizace',
  personalizationDescription: 'Přizpůsobte si pokyny, kterými se asistent řídí při každé odpovědi.',
  languageAndRegion: 'Jazyk a region',
  languageAndRegionDescription: 'Vyberte jazyk a časové pásmo.',
  memories: 'Vzpomínky',
  memoriesDescription: 'Zobrazte, upravte nebo odstraňte, co si o vás asistent pamatuje.',
  account: 'účet',
  accountDescription: 'Správa účtu a trvalé smazání vašich dat.',
  backToSettings: 'Zpět do nastavení',
  closeSettings: 'Zavřete nastavení',
  settingsCategories: 'Kategorie nastavení',
  yourSettings: 'Vaše nastavení',
  dataAndAccount: 'Data a účet',
  viewAndManageMemories: 'Zobrazte a spravujte, co si asistent pamatuje',
  loginToUseMemories: 'Chcete-li používat vzpomínky, přihlaste se',
  manageOrDeleteAccount: 'Spravujte nebo smažte účet',
  unsavedChanges: 'Máte neuložené změny',
  unsavedCloseDescription: 'Zavřením nastavení zrušíte změny na této stránce.',
  unsavedBackDescription: 'Návratem zpět zrušíte změny na této stránce.',
  continueEditing: 'Pokračujte v úpravách',
  discardChanges: 'Zahodit změny',
  saveChanges: 'Uložte změny',
  localSettingsNote: 'Uloženo v tomto prohlížeči. Pro uložení do účtu se přihlaste.',
  personality: 'Osobnost',
  personalityHelp: 'Vlastní pokyny, které asistent dodržuje při každé odpovědi',
  personalityPlaceholder:
    'Například: Buďte struční a konkrétní. Žiji v Göteborgu a mám rád vegetariánské jídlo.',
  timezone: 'Časové pásmo',
  searchTimezone: 'Hledat časová pásma…',
  automaticBrowser: 'Automaticky (prohlížeč)',
  saved: 'Uloženo {date}',
  addMemory: 'Přidat vzpomínku',
  newMemory: 'Nová vzpomínka',
  memoryPlaceholder: 'Například: Preferuji krátké a konkrétní odpovědi.',
  editMemory: 'Upravit vzpomínku',
  saveMemory: 'Uložit vzpomínku',
  deleteMemory: 'Smazat vzpomínku',
  memorySaveFailed: 'Paměť se nepodařilo uložit. Zkuste to znovu.',
  memoryLimitReached: 'Můžete uložit až 50 vzpomínek. Před přidáním další jednu smažte.',
  memoryInvalid: 'Vzpomínky nemohou obsahovat odkazy. Odstraňte odkaz a zkuste to znovu.',
  memoryDeleteFailed: 'Paměť se nepodařilo vymazat. Zkuste to znovu.',
  memoryLoadFailed: 'Vzpomínky se nepodařilo načíst.',
  loadingMemories: 'Načítání vzpomínek…',
  emptyMemories:
    'Asistent ukládá vzpomínky na vás, když mluvíte – co se vám líbí, kde žijete a co děláte. Zde je můžete prohlížet, upravovat a mazat.',
  deleteAccountHelp: 'Trvale smažte účet a všechny související chaty, vzpomínky a nastavení.',
  deleteAccount: 'Smazat účet',
  deleteAccountQuestion: 'Trvale smazat účet?',
  deleteAccountDescription:
    'Všechny chaty, zprávy, vzpomínky, nastavení a přihlašovací údaje budou smazány. Tuto akci nelze vrátit zpět.',
  deleteAccountConfirm: 'Ano, smazat můj účet',
  accountDeleteFailed: 'Účet se nepodařilo smazat. Nic nebylo odstraněno – zkuste to znovu.',
  logoutEverywhereTitle: 'Všechna zařízení',
  logoutEverywhereHelp:
    'Odhlaste se na všech zařízeních a v prohlížečích, kde je váš účet otevřený, včetně tohoto.',
  logoutEverywhere: 'Odhlásit se všude',
  logoutEverywhereQuestion: 'Odhlásit se na všech zařízeních?',
  logoutEverywhereDescription:
    'Na všech zařízeních a v prohlížečích, včetně tohoto, se budete muset znovu přihlásit. Vaše chaty a nastavení zůstanou beze změny.',
  loggingOut: 'Odhlašování…',
  logoutEverywhereFailed:
    'Nepodařilo se ověřit, že jste byli odhlášeni všude. Zkuste to znovu, nebo na jiném zařízení ověřte, zda jste stále přihlášeni.',
  settingsSaveFailed: 'Nastavení se nepodařilo uložit. Zkuste to znovu.',
  customInstructions: 'Vlastní pokyny',
  notSet: 'Není nastaveno',
  automaticLanguage: 'Automatický jazyk',
  automaticTimezone: 'automatické časové pásmo',
  appLanguage: 'Jazyk aplikace',
  appLanguageHelp:
    'Ovládá celé rozhraní aplikace a data. Odpovědi asistenta se nadále řídí jazykem, ve kterém píšete.',
  automaticBrowserLanguage: 'Automaticky (jazyk prohlížeče)',
  previousLanguageChoice: 'Předchozí výběr: {language} ({locale})',
  previousLanguageChoiceCode: 'Předchozí výběr ({locale})',
  canvasCopyLink: 'Kopírovat odkaz',
  canvasLinkCopied: 'Odkaz zkopírován',
  actionUpdatedWithEdits: 'Aktualizováno podle vašich úprav',
  activityStepsDone:
    'one:krok dokončen|few:kroky dokončeny|many:kroku dokončeno|other:kroků dokončeno',
  activityResultsCount: 'one:výsledek|few:výsledky|many:výsledku|other:výsledků',
  canvasCopyLinkFailed: 'Odkaz se nepodařilo zkopírovat',
  canvasOpenInAgent: 'Otevřít v aplikaci {agent}',
  canvasExpand: 'Rozbalit',
  canvasExitFullView: 'Ukončit celé zobrazení',
  webSourceUnread: 'Odkaz v této odpovědi. Poneva tuto stránku nečetla, takže tu není co zobrazit.',
  webSourceOpenOriginal: 'Otevřít originál',
  toolProgressSettings: 'Měním vaše nastavení…',
  toolProgressAgent: 'Vytvářím agenta…',
  toolProgressConnections: 'Hledám možnosti připojení…',
  toolProgressResult: 'Připravuji váš výsledek…',
  toolProgressClarification: 'Připravuji upřesnění…',
  toolProgressKnowledge: 'Připravuji navrhovanou aktualizaci znalostí…',
  toolProgressQuestion: 'Připravuji pro vás otázku…',
  toolProgressSkill: 'Tvoříme váš Skill…',
  toolErrorSettings: 'Vaše nastavení nebylo změněno.',
  toolErrorAgent: 'Agenta se nepodařilo vytvořit.',
  toolErrorConnections: 'Možnosti připojení se nepodařilo načíst.',
  toolErrorResult: 'Výsledek nebyl uložen.',
  toolErrorClarification: 'Upřesnění se nepodařilo připravit.',
  toolErrorKnowledge: 'Navrhovanou aktualizaci znalostí se nepodařilo připravit.',
  toolErrorQuestion: 'Otázku se nepodařilo připravit.',
  toolErrorSkill: 'Koncept Skillu se nepodařilo uložit.',
  toolErrorOpenSettings: 'Otevřít Nastavení',
  toolErrorOpenAgents: 'Otevřít Agenty',
  toolErrorOpenConnections: 'Otevřít Připojení',
  toolStepIncomplete: 'Tento krok nebyl dokončen.',
  toolEarlierAttemptsFailed:
    'one:dřívější pokus neprošel|few:dřívější pokusy neprošly|many:dřívějšího pokusu neprošlo|other:dřívějších pokusů neprošlo',
} satisfies AppCopy;
